export const APPROVED_AUTHORS = {
  quinn: {
    key: 'quinn',
    name: 'Quinn',
    title: 'Founder, Touchstone',
    expertise: 'AI tools, developer workflows, tool evaluation methodology',
    topics: [
      'Language Model',
      'Code Assistant',
      'Orchestration',
      'Vector Database',
      'Agents',
      'Deployment',
      'Observability',
      'Embeddings',
      'Data Processing',
      'Guardrails',
      'Evaluation',
      'Image Generation',
      'Audio/Voice',
      'Video Generation',
      'AI Tools',
    ],
    bio: 'Founder of Touchstone. Builds neutral AI tool research and evaluation infrastructure.',
  },
  'touchstone-team': {
    key: 'touchstone-team',
    name: 'Touchstone Team',
    title: 'Editorial Research Team',
    expertise: 'Neutral AI tool research, workflow analysis, and editorial review',
    topics: [
      'Language Model',
      'Code Assistant',
      'Orchestration',
      'Vector Database',
      'Agents',
      'Deployment',
      'Observability',
      'Embeddings',
      'Data Processing',
      'Guardrails',
      'Evaluation',
      'Image Generation',
      'Audio/Voice',
      'Video Generation',
      'AI Tools',
    ],
    bio: 'Touchstone editorial team maintaining neutral AI tool research, comparison updates, and methodology reviews.',
  },
};

export function getApprovedAuthor(key) {
  return APPROVED_AUTHORS[key] || null;
}
